'use client';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import * as Sentry from '@sentry/nextjs';
import Flash from '@/ui/Flash';
import { Stack } from '@/ui/primatives';

interface Props {
  children?: ReactNode;
  errorMessage?: string;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
    Sentry.captureException(error);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <Flash.Error>
          <Stack.Centered gap={10}>
            <h6>{this.props.errorMessage || 'There was an error loading the file comparison for this commit.'}</h6>
            <p>The Oxen team has been notified of this issue and will be looking into it shortly.</p>
          </Stack.Centered>
        </Flash.Error>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
